import React, { useEffect, useContext } from 'react';
import { isStorageItem } from '../../utils/isStorageItem';
import BookerContext from '../../context/bookerContext';
import '../../assets/styles/error.sass';
import fieldParams from '../../const/fieldParams';
import CountryDropdown from 'country-dropdown-with-flags-for-react';

const CountryInput = ({ fieldKey }) => {
  const { key, label } = fieldParams[fieldKey];
  const context = useContext(BookerContext);
  const {
    state: { country, payment, editor },
    updatePayment,
    updateEditor,
    updateCountry,
  } = context;

  useEffect(() => {
    resetMapToMaxHeight();
  }, []);

  const resetMapToMaxHeight = () => {
    const headerContainer = document.querySelector('.header');
    const dropdownContainer = document.querySelector('.country-dropdown-container');
    const countryListContainer = document.querySelector('.country-list');

    const heightOfWindow = window.innerHeight;
    const headerContainerHeight = headerContainer.clientHeight;
    const dropdownContainerHeight = dropdownContainer.clientHeight;

    const height = heightOfWindow - headerContainerHeight - dropdownContainerHeight;

    countryListContainer.style.setProperty('max-height', `${height}px`);
  };

  const sendCountryValue = () => {
    const selected = document.querySelector('.country.active');
    const countryId = selected.dataset.countryCode;
    const countryName = selected.textContent;

    payment.zip = '';
    updatePayment(payment);

    const editor = isStorageItem('editor');
    const { previousKey, isOpenedFromMenu } = editor || {};
    updateEditor(isOpenedFromMenu ? { key: previousKey, isOpenedFromMenu } : '');
    updateCountry({ id: countryId, name: countryName, selected: true });
  };

  return (
    <div className={`form-group form-group-${key}`}>
      <div className="message-container">
        <label htmlFor={key} className="form-label">
          {label}
        </label>
        <CountryDropdown
          id="country-selector"
          className="country-dropdown-container"
          preferredCountries={['au', 'ca', 'cn', 'fr', 'in', 'jp', 'mx', 'pr', 'gb', 'us']}
          value={`${country.name}`}
          handleChange={sendCountryValue}
        />
      </div>
    </div>
  );
};

export default CountryInput;
